import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './utils/v-draggable'
import "lib-flexible/flexible";
// import "element-ui/lib/theme-chalk/index.css";
// import { Select, Option, Input,Descriptions,Image  } from "element-ui";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import MaskLoading from "@/components/pub/MaskLoading";
import cryptojs from '@/utils/cryptojs'
import './utils/v-slidein'
Vue.prototype.$cryptojs = cryptojs;
// Vue.use(Select);
// Vue.use(Option);
// Vue.use(Input);
// Vue.use(Descriptions);
// Vue.use(Image);
Vue.use(ElementUI);
Vue.component("m-loading", MaskLoading);

import {
	Notify,
	Toast,
	Switch,
	Icon,
	List,
	Button,
	Field,
	Form,
	Popup,
	Area,
	Cell,
	CellGroup,
	Uploader,
	Picker,
	Checkbox,
	Tag,
	Calendar,
	Dialog,
	Swipe,
	SwipeItem,
	ActionSheet,
	Collapse,
	CollapseItem,
	Step,
	Steps,
	Loading,
	ImagePreview,
	Overlay,
	DatetimePicker,
	NumberKeyboard,
	Grid,
	GridItem,
	Image,
	Popover,
	RadioGroup,
	Radio,
	Sticky
} from "vant";
Vue.use(Sticky);
Vue.use(Notify);
Vue.use(DatetimePicker);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Switch);
Vue.use(Icon);
Vue.use(List);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Popover);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Checkbox);
Vue.use(Tag);
Vue.use(Calendar);
Vue.use(Dialog);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(ActionSheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ImagePreview);
Vue.use(NumberKeyboard);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Image);
Vue.use(RadioGroup);
Vue.use(Radio);
const whiteList = [
	"/",
	"/login",
	"/register",
	"/wxlogin",
	"/loginchoice",
	"/useragreement",
	"/loginjudge",
	"/loginorg",
	"/orgregister",
	"/loginchannel",
	"/pwdretrieve",
	"/home/index",
	"/home/newsdetail",
	"/player/photodetail",
	"/home/application",
	"/home/queryCheck",
	"/inviteMechanism",
	"/inviteChannel",
	"/inviteJudge",
	"/question",

];
import {
	localStorageSetItem, localStorageGetItem
} from '@/utils/auth'
router.beforeEach(async (to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	} else {
		document.title = "书画大赛";
	}
	let toQuery = { ...to.query }
	if (to.query['TENANT-ID']) {
		localStorageSetItem('TENANT-ID', to.query['TENANT-ID'])
	} else if (from.query['TENANT-ID']) {
		toQuery['TENANT-ID'] = from.query['TENANT-ID'];
	} else if (localStorageGetItem("TENANT-ID") != 'null' && localStorageGetItem("TENANT-ID") != 0) {
		toQuery['TENANT-ID'] = localStorageGetItem("TENANT-ID");
	}
	const role = store.state.role;
	if (whiteList.includes(to.path)) {
		if (role == 1 && to.path === "/") {
			next("/home/remark");
		} else {
			if (to.query['TENANT-ID'] || to.query['TENANT-ID'] == 0 || !toQuery['TENANT-ID']) {
				next();
			} else {
				next({
					path: to.path,
					query: toQuery,
				})
			}
		}
	} else {
		if (to.path == "/bmcx") {
			document.title = "报名查询系统";
			next();
		}
		const userInfo = store.state.userInfo;
		const isLogin = userInfo && userInfo.token;
		if (!isLogin && to.path != "/bmcx" && to.path != "/scanPage") {
			localStorage.setItem('page', to.path)
			Toast.fail({
				duration: 1500,
				message: "登录信息已过期，请重新登录",
				onClose: () => {
					next("/login");
				}
			});
		} else {
			if (role == 1 && to.path === "/") {
				next("/home/remark");
			} else {
				if (to.query['TENANT-ID'] || to.query['TENANT-ID'] == 0 || !toQuery['TENANT-ID']) {
					next();
				} else {
					next({
						path: to.path,
						query: toQuery,
					})
				}
			}
		}
	}
});
Vue.prototype.$toast = Toast;
Vue.prototype.$Dialog = Dialog;
Vue.prototype.$notify = Notify;
Vue.prototype.$ImagePreview = ImagePreview;
// 在ios系统中，$router.push 会导致js 签名失效
Vue.prototype.mipLink = (href, query = null) => {
	let url = window.location.origin + href;
	if (query) {
		let params = "";
		let s = true;
		for (let key in query) {
			if (s) {
				params += `?${key}=${query[key]}`;
				s = false;
			} else {
				params += `&${key}=${query[key]}`;
			}
		}
		url += params;
	}
	window.location.href = url;
};
// 设置图片显示
Vue.directive("setshow", function (el) {
	if (el.height > el.width) {
		el.style.width = "100%";
		el.style.height = "unset";
	} else {
		el.style.height = "100%";
		el.style.width = "unset";
	}
});
// 清空jsSDK token 刷新页面
Vue.prototype.refreshJSToken = (refr = false) => {
	store.commit("SET_JSSDK_ACCESS_TOKEN", null);
	if (refr) {
		const href = window.location.href;
		window.location.href = href;
	}
};

Vue.config.productionTip = false;
new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount("#app");